// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--10wNk","Popover":"Popover--RGDGn","CloseIcon":"CloseIcon--1GSvi","Dot":"Dot--2VBh1","Tag":"Tag--22lHN"};